import type { GetStaticProps } from 'next'
import type { BlogPost } from '@/types'

import { Seo } from '@/components/generals/seo'
import { PageHero } from '@/components/layout/page-hero'
import { MarqueeBand } from '@/components/layout/marquee-band'
import { BlogGrid } from '@/components/blog/blog-grid'
import { getBlogPosts } from '@/lib/content'

interface BlogPageProps {
    posts: BlogPost[]
}

export default function BlogPage({ posts }: BlogPageProps) {
    return (
        <>
            <Seo
                title='Thoughts'
                description='Notes on design, motion, and building for the web.'
            />
            <PageHero
                titleTop='My'
                titleBottom='Blog'
                detail='Notes on design, motion, and building long lasting digital experiences.'
            />
            <div className='section'>
                <div className='container'>
                    <BlogGrid posts={posts} />
                </div>
            </div>
            <MarqueeBand words={['BLOG POSTS', 'FROM', 'THE PAST.']} />
        </>
    )
}

export const getStaticProps: GetStaticProps<BlogPageProps> = async () => {
    const posts = await getBlogPosts()
    return { props: { posts }, revalidate: 60 }
}
